var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"fill-rule":"evenodd","fill":"none"}},[_c('path',{attrs:{"d":"M-2-2h24v24H-2V-2z"}}),_c('path',{attrs:{"d":"M7.5.5v19h-3V.5h3zm8 0v19h-3V.5h3z","fill-rule":"nonzero","fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }